module.exports = "pegasus_template/assets/blocks/tile-layout-07.png";